<greco-event-templates-details [eventTemplate]="eventTemplate"></greco-event-templates-details>
